<template>
  <div class="not-found-page">
    <section class="not-found-card">
      <h1>Opps!</h1>
      <p class="lead">
        We can&rsquo;t seem to find the
        <br class="desktop-break">
        page you&rsquo;re looking for.
      </p>
      <hr>
      <p class="error-code">Error code: 404</p>
      <p class="help-text">Heres some helpful links instead:</p>
      <nav class="not-found-links" aria-label="Helpful links">
        <router-link to="/">Home</router-link>
        <router-link to="/login">Login</router-link>
        <router-link to="/">Quotes</router-link>
        <router-link to="/contact">Customers</router-link>
        <router-link to="/help">Help</router-link>
      </nav>
    </section>
  </div>
</template>

<style scoped>
.not-found-page {
  min-height: calc(100vh - 48px);
  padding: 78px 24px 48px;
}

.not-found-card {
  width: 100%;
  max-width: 640px;
  margin: 0 auto;
}

h1 {
  margin: 0;
  font-family: var(--font-bold);
  font-weight: 500;
  font-size: 50px;
  line-height: 1;
  letter-spacing: 0.2px;
  color: var(--color-dark-grey);
}

.lead {
  margin: 24px 0 28px;
  font-family: var(--font-semibold);
  font-size: 47px;
  line-height: 1.13;
  letter-spacing: 0.2px;
  color: var(--color-dark-grey);
}

hr {
  border: 0;
  border-top: 1px solid var(--color-border);
  margin: 0 0 24px;
}

.error-code,
.help-text {
  margin: 0;
  font-family: var(--font-regular);
  font-size: 32px;
  line-height: 1.25;
  color: var(--color-dark-grey);
}

.help-text {
  margin-top: 24px;
}

.not-found-links {
  display: flex;
  flex-direction: column;
  margin-top: 4px;
}

.not-found-links a {
  width: max-content;
  font-family: var(--font-semibold);
  font-size: 32px;
  line-height: 1.2;
  color: var(--color-primary);
  text-decoration: none;
}

@media screen and (min-width: 768px) {
  .not-found-page {
    padding-top: 98px;
  }

  h1 {
    font-size: 44px;
  }

  .lead {
    margin-top: 18px;
    margin-bottom: 24px;
    font-size: 46px;
    line-height: 1.08;
  }

  .error-code,
  .help-text {
    font-size: 26px;
    line-height: 1.2;
  }

  .help-text {
    margin-top: 20px;
  }

  .not-found-links a {
    font-size: 24px;
    line-height: 1.2;
  }
}

@media screen and (max-width: 767px) {
  .desktop-break {
    display: none;
  }
}
</style>
